/**
 * Created by tofael on 3/22/17.
 */

import actions from '../actions/types';

const initialState = {
  name:'',
  id:'',
  admin:false,
  superAdmin:false
}
export default function reducer( state = initialState,action) {
  switch (action.type) {

    case actions.SET_USER: {
      const { name, admin, id } = action.data;
      state = {
        name,
        admin,
        id,
        loggedIn:true
      }
      break;
    }

    case actions.DESTROY_USER: {
      state = initialState;
      break;
    }

    default:
      return state;
  }

  return state;
}


// WEBPACK FOOTER //
// ./src/reducers/user.js